module.exports = __webpack_public_path__ + "static/media/bus-eireann.b8bac770.jpg";